__turbopack_context__.v({
  "className": "YNDNGG_className",
  "variable": "YNDNGG_variable",
});
